import { render } from "./StrikeTheShape.vue?vue&type=template&id=851b9072&scoped=true"
import script from "./StrikeTheShape.vue?vue&type=script&lang=js"
export * from "./StrikeTheShape.vue?vue&type=script&lang=js"

import "./StrikeTheShape.vue?vue&type=style&index=0&id=851b9072&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851b9072"]])

export default __exports__